import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { BASE_QUERY_KEY } from "../../utils/constants";
import {
  AccessRequestSubmittedClientResponse,
  RequestAgainClientModel,
} from "../../api/v1";

import useAccessRequestsApi from "./use-access-requests-api";

export default function useRequestAgainAccessRequest(id: string) {
  const queryClient = useQueryClient();
  const api = useAccessRequestsApi();

  const {
    mutate: requestAgainAccessRequest,
    mutateAsync: requestAgainAccessRequestAsync,
    ...rest
  } = useMutation<
    AccessRequestSubmittedClientResponse,
    AxiosError,
    RequestAgainClientModel
  >(
    async (payload: RequestAgainClientModel) => {
      const res = await api.requestAgainAccessRequest({
        id,
        requestAgainClientModel: {
          ...payload,
          run_pre_approval_validations: true,
        },
      });
      return res;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
      },
    },
  );

  return {
    requestAgainAccessRequest,
    requestAgainAccessRequestAsync,
    ...rest,
  };
}
